// Theme
import initChoices from './choices';
import initFlatpickr from './flatpickr';
import initToast from './toast';
import initTab from './tab';
import initTooltip from './tooltip';
import initPopover from './popover';

import initLoader from './loader';
import initCart from './cart';
import initFlyout from './flyout';
import initLottie from './lottie';
import initNumberBtn from './number-btn';
import initPassword from './password';
import initCollapse from './collapse';
import initStickyHead from './sticky-head';
import initDropzone from './dropzone';
import initStickyNav from './sticky-nav';
import initSearchClear from './search-clear';

initChoices();    // https://github.com/Choices-js/Choices
initFlatpickr();  // https://flatpickr.js.org
initToast();      // https://getbootstrap.com/docs/5.2/components/toasts
initTab();        // https://getbootstrap.com/docs/5.2/components/navs-tabs
initTooltip();    // https://getbootstrap.com/docs/5.2/components/tooltips
initPopover();    // https://getbootstrap.com/docs/5.2/components/popovers
initDropzone();   // https://www.dropzone.dev/js

initLoader();     // Hide loader on page load
initCart();       // Move columns on cart expand
initFlyout();     // Product preview
initLottie();     // Product ammo animation
initNumberBtn();  // Minus/plus btn
initPassword();   // Show/Hide password 
initCollapse();   // Reset radio buttons on collapse
initStickyHead(); // Products sticky heading
initStickyNav();  // Products sticky nav
initSearchClear();// Clear search input
